import React, { useMemo, useState } from "react"
import { get, merge } from "lodash"

const calc_string = "RCI =｛1 - 6 × d / (n×(n**2-1))} × 100(%)"

const addon = [
  // 移動平均
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          移動平均線は、過去の一定期間の終値平均値から求めます。
          <br />
          終値(0)を注目する4本値の終値とし、終値(n)をn個前終値を表すとすれば以下の計算式で求めます。
          <br />
        </div>
        <div className="chart-text-calc">
          ( 直近の終値(0) + 1本前の終値 + 2本前の終値 … + (N-1)本目の終値 ）÷ N
        </div>
      </div>
    )
  },
  // ボリンジャーバンド
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          移動平均に対してその標準偏差(σ)の+-1、+-2倍の位置をプロットして作成します。
        </div>
        <div className="chart-text-calc">
          <div className="chart-text-title">標準偏差：σ(シグマ)</div>
          = √(n×n区間の終値の2乗の合計 - n日間の終値の合計の2乗) / (n期間 ×
          (n期間-1))
          <br />
          <div className="chart-text-title">±1σライン</div>
          移動平均線の数値±標準偏差*k (k=1.0の時が、1σ)
          <br />
          <div className="chart-text-title">±2σライン</div>
          移動平均線の数値±2 × 標準偏差*k (k=1.0の時が、2σ)
        </div>
      </div>
    )
  },
  // 移動平均エンベロープ
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          移動平均線を一定の割合で上下に乖離させたものです。
          <br />
          pを乖離率(%)としてEnvUp
          (上バンド)、EnvDn(下バンド)は以下の式で求めます。
        </div>
        <div className="chart-text-calc">
          EnvUp = N日間移動平均線 × (1 + p/100)
          <br />
          EnvDn = N日間移動平均線 × (1 - p/100)
        </div>
      </div>
    )
  },
  // 一目均衡表
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          転換線、基準線、先行スパン1、先行スパン2、遅行スパンを指標とします。
          <br />
          2本の先行スパンに囲まれた部分は雲と呼ばれる。
          <br />
          N1を転換線期間、N2を基準線期間、N3をスパン期間として以下のように求めます。
        </div>
        <div className="chart-text-calc">
          <div className="chart-text-title">転換線</div>
          (当日を含む過去N1日間の最高値 + 最安値) / 2を当日とした折れ線グラフ
          <br />
          <div className="chart-text-title">基準線</div>
          (当日を含む過去N2日間の最高値 + 最安値) / 2を当日とした折れ線グラフ
          <br />
          <div className="chart-text-title">先行スパン1</div>
          (転換線+基準線)/2を、N2日先行した折れ線グラフ
          <br />
          <div className="chart-text-title">先行スパン2</div>
          (当日を含む過去N3日間の最高値+最安値)/2をN2日先行した折れ線グラフ
          <br />
          <div className="chart-text-title">雲</div>
          先行スパン1と先行スパン2の間部分(抵抗帯)
          <br />
          <div className="chart-text-title">遅行スパン</div>
          当日の終値をN2日遅行した折れ線グラフ
        </div>
      </div>
    )
  },
  // パラボリック
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          描かれた放物線と実際の価格の交差するポイントが売買転換点を示す(SAR =
          Stop And Reverse)テクニカル指標です。
          <br />
          一般的にローソク足がパラボリックの上にある場合は、「上げ相場」を示し、下にある場合は「下げ相場」を示します。
          <br />
          計算式は次のようになります。
        </div>
        <div className="chart-text-calc">
          <div className="chart-text-title">SAR(売買転換点)</div>
          前日のSAR + AF × (EP - 前日のSAR）
          <br />
          <div className="chart-text-title">AF</div>
          加速因子（初期値 ≦ AF ≦ 0.20(MaxAF)）
          <br />
          初期値が0.02で、終値が高値を更新するたびに、ステップ数(+0.02)ずつ加算されます。
          <div className="chart-text-title">EP</div>
          買い持ちしている期間の最高値、または売り持ちしている期間の最安値
        </div>
      </div>
    )
  },
  // HLバンド
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          HL(ハイロー)バンドは、注目する日付(時刻)の一つ前からN期間さかのぼった高値、安値をプロットし、高値更新、安値更新を見易くしたものです。
          <br />
          また、Hバンド、Lバンドの平均値に中間線を引いて補助指標としています。
          <br />
          n1を高値算出期間、n2を安値算出期間とすれば以下の通りとなります。
        </div>
        <div className="chart-text-calc">
          <div className="chart-text-title">Hバンド</div>
          高値(1) ～　高値(n1+1) の最高値
          <div className="chart-text-title">Lバンド</div>
          安値(1) ～　安値(n2+1) の最安値
        </div>
      </div>
    )
  },
  // ATRチャネル
  () => {
    return (
      <div>
        <div className="chart-text-desc">以下の計算式で求めます。</div>
        <div className="chart-text-calc">
          真の変動幅(True Range)の算出する。
          <br />
          ① 当日高値と当日安値の差
          <br />
          ② 当日高値と前日終値の差
          <br />
          ③ 当日安値と前日終値の差
          <br />
          ①～③で最大の幅になるものをTR(True Range)とする。
          <br />
          <div className="chart-text-title">
            ATR = TRのn2日間のEMA(指数平滑移動平均)を計算する。
          </div>
          中心線は、ATRのn1日間の線形荷重移動平均で作成する。
          <br />
          バンド線 現在の終値 + ATRの値 × 乗数(n3/n4/n5)
        </div>
      </div>
    )
  },
  // 指数平滑移動平均
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          直近の値動きを重視して、移動平均線を算出することで、瞬間的に大きな変動が起きた場合に単純移動平均と比較して、トレンドの転換点を分析する指標です。
        </div>
        <div className="chart-text-calc">
          指数平滑移動平均線(EMA)
          <br />
          初日の計算 単純移動平均の値を採用
          <br />
          2日目以降の計算　EMA(n) = EMA(n-1) +α ×｛終値(0) - EMA(n-1)｝
          <br />
          n：対象期間　α(平滑化定数) = 2 / (n+1)
        </div>
      </div>
    )
  },
  // 回帰トレンド
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          回帰トレンドとは、値段の回帰直線に標準偏差の倍数を加えた(減じた)補助線を引いたものです。
          <br />
          本システムでは線形(1次)回帰トレンドを使用しています。
          <br />
          回帰直線は、値段列に対して最もフィットする直線であり、この直線の向きからトレンドの方向を見る事ができます。
          <br />
          上下の補助線の広さは、標準偏差の定数倍であることから、株価の変動率を表しています。
        </div>
        <div className="chart-text-calc">
          回帰直線を
          <br />
          y = b*x + a<br />
          a = n日終値平均値 - bxn日平均日数
          <br />
          b = Σ| (i-n日平均日数)*(i日目終値-n日終値平均値)| /
          Σ(i-n日平均日数)**2
          <br />
          <div className="chart-text-title">
            補助線は標準偏差をσ、m=-2,-1,+1,+2として以下の式で求めます。
          </div>
          Y(m) = a × X + b + m ×σ
          <br />
          <div className="chart-text-title">
            但し標準偏差σは以下の式で求めます。
          </div>
          σ = √( (Σ(Y-yi)**2) / n)
        </div>
      </div>
    )
  },
  // VWAP
  () => {
    return (
      <div>
        <div className="chart-text-calc">
          当日累積売買代金 ÷ 当日累積出来高を表示する(分足のみ)
        </div>
      </div>
    )
  },
]

const tools = [
  // 転換点
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          1.指定期間での過去、未来の最高値、最安値を調べる
          <br />
          2.最高値なら天、最安値なら底かどうかの判定をする。
          <br />
          3.判定
        </div>
        <div className="chart-text-desc">
          1.直前の転換点と天か底かが逆の場合
          <br />
          直前の転換点のリバーサル値(後述)を越えている(天としての判定時)もしくは下回っている(底としての判定時)なら転換点とする。
        </div>
        <div className="chart-text-desc">
          2.直前の転換点と同じ
          <br />
          直前の転換値を超えている(天としての判定時)もしくは下回っている(底としての判定時)なら直前の転換点を上書き更新して新たな転換点とする。
        </div>
        <div className="chart-text-desc">
          3.直前の転換点がない場合、無条件に転換点とする。
          <br />
          ※転換点はその転換点が生じたときの値を転換値、天と底を入れ替えるべきかの判定をするかの値をリバーサル値とする。
        </div>
        <div className="chart-text-desc">
          リバーサル値は
          <div className="chart-text-title">天の時</div>
          転換値 + (期間分の過去の中での最安値-転換値) × 0.5
          <br />
          <div className="chart-text-title">底の時</div>
          転換値 + (期間分の過去の中での最高値-転換値) × 0.5
          <br />※ 直近の期間分については転換点評価対象としない。
        </div>
      </div>
    )
  },
  // 価格帯別出来高
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          価格帯別出来高は、銘柄の価格幅を10分割して、チャートエリア左に表示します。
          <br />
          最大値表示で、棒グラフの最大値をラベル表示します。
          <br />
          グリッド間で棒グラフを標準で4分割しているが、1/2指定で8分割、X2は2分割に変更できます。
        </div>
      </div>
    )
  },
  // 日柄分析
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          日柄とは、株かの上げ下げにかかる日数のことを言います。
          <br />
          全日柄は、転換点の天ー底、底ー点間表示グラフを表示します。
          <br />
          高値日柄は、転換点の天間表示グラフを表示します。
          <br />
          安値日柄は、転換点の底間表示グラフを表示します。
        </div>
      </div>
    )
  },
]

const subchart = [
  // RSI
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          過去N期間の値動き幅に対する上昇幅の割合を百分率で表したものです。
        </div>
        <div className="chart-text-calc">
          RSI = N日間の値上がり幅平均 ÷ (N日間の値上がり幅平均 +
          N日間の値下がり幅平均) × 100
        </div>
      </div>
    )
  },
  // ストキャスティクス
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          株価の「買われ過ぎ・売られ過ぎ」という状態を見るために、過去何日かにおける高値、安値に対し現在(終値)どの位置にいるかを表しています。
          <br />
          n1を%K期間、n2を%D期間中として%K,%Dを以下の式で求めます。
        </div>
        <div className="chart-text-calc">
          %K = (当日終値 - n1日間の最安値) ÷ (n1日間の最高値 - n1日間の最安値) ×
          100
          <br />
          %D = A ÷ B × 100
          <br />
          ＊A = (当日終値 - n1日間の最安値) のn2日間合計、B = (n1日間の最高値 -
          n1日間の最安値) のn2日間合計
          <br />
          S%D = %Dのn3期間の移動平均
        </div>
      </div>
    )
  },
  // スローストキャスティクス
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          株価の「買われ過ぎ・売られ過ぎ」という状態を見るために、過去何日かにおける高値、安値に対し現在(終値)どの位置にいるかを表しています。
          <br />
          n1を%K期間、n2を%D期間中として%K,%Dを以下の式で求めます。
        </div>
        <div className="chart-text-calc">
          %K = (当日終値 - n1日間の最安値) ÷ (n1日間の最高値 - n1日間の最安値) ×
          100
          <br />
          %D = A ÷ B × 100
          <br />
          ＊A = (当日終値 - n1日間の最安値) のn2日間合計、B = (n1日間の最高値 -
          n1日間の最安値) のn2日間合計
          <br />
          S%D = %Dのn3期間の移動平均
        </div>
      </div>
    )
  },
  // %R
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          期間nの高値と安値の値幅に対する終値の相対的な位置を見ます。
        </div>
        <div className="chart-text-calc">
          %R = -100［ (Hn - C) / (Hn - Ln) ］
          <br />
          C = 直近の終値(日中であれば現在値)
          <br />
          Ln = 過去n日間の最安値
          <br />
          Hn = 過去n日間の最高値
        </div>
      </div>
    )
  },
  // MACD
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          MACDはn1を期間1、n2を期間2、として、指数平滑移動平均(EMA)を使って、以下の式で求めます。
        </div>
        <div className="chart-text-calc">MACD = EMA(n1) - EMA(n2)</div>
      </div>
    )
  },
  // CCI
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          一日ごとの高値、安値、終値の平均値(TP)を算出します。ここではこの値を「基準値」と呼びます。さらに、この基準値のn日間単純移動平均を算出します。さらに、一日ごとの基準値と移動平均の値の差のn日間平均(平均偏差)を求めます。
          <br />
          以上の３つを算出したら、以下の式に代入します。
        </div>
        <div className="chart-text-calc">
          CCI = (基準値 - 基準値の移動平均値) / 0.015 × 平均偏差(n日間)
          <br />
          平均偏差 = Σ| (基準値 - 基準値の移動平均値) | / n
        </div>
      </div>
    )
  },
  // サイコロジカル
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          サイコロジカルラインの「サイコロジカル」とは「心理的な」という意味です。その名の通り、投資家心理を数値化しているのがこのテクニカル指標です。
          <br />
          計算式は、以下となります。
        </div>
        <div className="chart-text-calc">
          サイコロジカルライン(%) = (n日間のうち終値比プラスの日数) ÷ n × 100
        </div>
      </div>
    )
  },
  // ATR
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          ボラティリティ(変動率)を表す指標で、「当日高値 - 当日安値」「当日高値
          - 前日高値」「前日終値 -
          当日高値」の3つのうち最大の値幅(マド明けを含む最大値幅の計測)を当日の「真の値幅(トゥルーレンジ
          = True Range)」と呼び、このn日指数平滑移動平均線(EMA)がATRといいます。
        </div>
        <div className="chart-text-calc">ATR = True Range の n日間のEMA</div>
      </div>
    )
  },
  // アルーン・インジケーター
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          アルーン(Aroon)はアルーンアップ(Aroon Up)とアルーンダウン(Aroon
          Down)の2本線で構成されています。
          <br />
          アルーンアップ(AroonUp)は、高値を更新した回数が、設定期間中どのくらいあったかをパーセンテージで表示します。
          <br />
          アルーンダウン(AroonDown)は、安値を更新した回数が、設定期間中どのくらいあったかをパーセンテージ表示します。
          <br />
          NUPをアルーンアップ期間、NDNをアルーンダウン期間、IMAXをNUP期間前の足(0番目)から現在に向かって数えた最高値を示した足の番号、IMINをNDN期間前から同様に最安値を示した足の番号として以下の式で求めます。
        </div>
        <div className="chart-text-calc">
          AroonUp = IMAX / NUP × 100
          <br />
          AroonDown = IMAX / NDN × 100
        </div>
      </div>
    )
  },
  // アルーン・オシレーター
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          アルーンアップとアルーンダウンの差です。 以下の式で求めます。
        </div>
        <div className="chart-text-calc">
          AroonOscilator = AroonUP - AroonDown
        </div>
      </div>
    )
  },
  // 移動平均乖離率
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          移動平均値と終値の乖離(開き)を移動平均値の基準とした百分率で表したものです。
          <br />
          以下の計算式で求めます。(MA(n)は期間nの移動平均値)
        </div>
        <div className="chart-text-calc">
          乖離率(ERMA(n)) = (終値 - MA(n)) ÷ MA(n) × 100(%)
        </div>
      </div>
    )
  },
  // 売買高
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          終値の代わりに売買高を使用した移動平均線計算を行う。
        </div>
      </div>
    )
  },
  // RCI
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          n期間内の日付(時間)と価格それぞれに順位をつけ、両者にどれだけの相関関係があるのかを計算し、相場のトレンドとその勢い、過熱感を知ることができます。
          <br />
          +100%に近いと高値圏、-100%に近いと安値圏であると捉えます。
        </div>
        <table className="chart-text-table">
          <thead>
            <tr>
              <th>日付</th>
              <th>終値</th>
              <th>A:時間順位</th>
              <th>B:値段順位</th>
              <th>(A-B)**2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>5月23日</td>
              <td>1907</td>
              <td>1</td>
              <td>3</td>
              <td>4</td>
            </tr>
            <tr>
              <td>5月22日</td>
              <td>1899</td>
              <td>2</td>
              <td>6</td>
              <td>16</td>
            </tr>
            <tr>
              <td>5月21日</td>
              <td>1901</td>
              <td>3</td>
              <td>5</td>
              <td>4</td>
            </tr>
            <tr>
              <td>5月20日</td>
              <td>1903</td>
              <td>4</td>
              <td>4</td>
              <td>0</td>
            </tr>
            <tr>
              <td>5月19日</td>
              <td>1909</td>
              <td>5</td>
              <td>2</td>
              <td>9</td>
            </tr>
            <tr>
              <td>5月16日</td>
              <td>1912</td>
              <td>6</td>
              <td>1</td>
              <td>25</td>
            </tr>
          </tbody>
        </table>
        <div className="chart-text-calc">
          {calc_string}
          <br />
          d:日付の順位と価格(終値)の差を2乗し、合計した数値
          <br />
          n:期間
        </div>
        <div className="chart-text-desc">
          日付の順位は当日(最新の日付)を「1」にします。そして、遡りながら「2、3、4、…」と順位をつけていきます。
          <br />
          価格はその計算期間の中での高い順に「1」から番号をつけていきます。ということは期間の最高値が「1」、2番目に高い価格に「2」をつけていきます。
          <br />
          上記RCIの式に期間は6、d = 58(=4+16+4+9+25) を代入して計算してみると
          RCI = -65.71 になります。
        </div>
      </div>
    )
  },
  // ROC
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          ROCとは計算期間内の価格の変化率を表したテクニカル指標で逆行現象、相場の勢い(強弱)、反転の目安となる水準を見ることが出来る指標です。
          <br />
          計算式は次のようになります。
        </div>
        <div className="chart-text-calc">
          ROC = 当日終値 / N日前の終値 × 100
        </div>
      </div>
    )
  },
  // モメンタム
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          N期間前との値段差であり、価格の変化率を見ます。モメンタム(期間N)は移動平均(期間N)の変化率に比例します。
          <br />
          計算式は、以下となります。
        </div>
        <div className="chart-text-calc">
          モメンタム = 当日の終値 - N日前の終値
        </div>
      </div>
    )
  },
  // DMI
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          +DI, -DI, ADX1, ADX2, ADXR1, ADXR2 の6本線で構成します。
          <br />
          修正平均のチェックの有無で、ADXの計算を、単純移動平均(チェックなし)か平滑移動平均(チェックあり)で計算します。
        </div>
        <div className="chart-text-desc">
          「はらみ」の時は、+DM=0、-DM=0
          <br />
          それ以外では、前日での高値をHP、安値をLP、当日の足での高値をHA、安値をLAとして
          <br />
          (HA-HP) ＞ (LP-LA) : +DM = (HA-HP)、-DM = 0
          <br />
          (HA-HP) ＜ (LP-LA) : +DM = 0、-DM = (LP-LA)
          <br />
          (HA-HP) = (LP-LA) : +DM = 0、-DM = 0<br />
          True Rangeは、前日の終値をCP、当日の高値をHA、当日の安値をLAとすると
        </div>
        <div className="chart-text-calc">
          TR = MAX((HA - LA),(HA - CP),(CP - LA))
        </div>
        <div className="chart-text-desc">
          +DI = (n1日間の+DMの合計）÷（n1日間のTRの合計）× 100
          <br />
          -DI = (n1日間の-DMの合計）÷（n1日間のTRの合計）× 100
          <br />
        </div>
        <div className="chart-text-desc">
          n2をADX期間、n3をADXR期間とすれば、
          <br />
          DX = (+DI - -DI)の絶対値 ÷ (+DI + -DI) × 100
          <br />
          ADX = n2日期間のDXの単純移動平均 (修正ADXの場合は、平滑移動平均)
          <br />
          ADXR = (n3日間のADX + 当日のADX) ÷ 2
        </div>
      </div>
    )
  },
  // 信用残
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          信用買残と信用売残を表示します。
          <br />
          週足の時のみ表示可能となっています。
        </div>
      </div>
    )
  },
  // 標準偏差
  () => {
    return (
      <div>
        <div className="chart-text-calc">
          ボラティリティ(n日) = 標準偏差(σ)
          <br />
          標準偏差 =
          √(n区間の終値の２乗の合計の平均)-(n日間の終値の合計の平均)*(n日間の終値の合計の平均)
        </div>
      </div>
    )
  },
  // 強弱レシオ
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          ① Aレシオ
          <br />
          「当日高値 − 当日始値」のn日間の合計値 ÷「当日始値 −
          当日安値」のn日間の合計値
        </div>
        <div className="chart-text-desc">
          ② Bレシオ
          <br />
          「当日高値 − 前日終値」のn日間の合計値 ÷「前日終値 −
          当日安値」のn日間の合計値
        </div>
      </div>
    )
  },
  // スプレッド
  () => {
    return (
      <div>
        <div className="chart-text-desc">
          比較チャート設定にて、現在チャート上で表示している主銘柄に加えて、他銘柄の値動きを重ねて表示します。
          <br />
          基準となる主銘柄と比較銘柄とのデータ差分を表示します。
        </div>
      </div>
    )
  },
]

const TOOLTIP_MAX_WIDTH = 540
const TOOLTIP_MAX_HEIGHT = 320
const X_PADDING = 16
const Y_PADDING = 8

export const useChartTechToolTip = (props: { type: number }) => {
  const { type } = props
  const [position, setPosition] = useState<
    { left?: number; right?: number; top?: number; bottom?: number } | {}
  >({})
  const _setPosition = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const innerWidth = window.innerWidth
    const innerHight = window.innerHeight
    const xAxis = e.clientX + X_PADDING
    const yAxis = e.clientY + Y_PADDING
    let param = {}
    // 『カーソルの位置　＋　ツールチップの大きさ』　がウィンドウ幅を超える場合、右ないしは下から計算して必ずツールチップが画面に入るようにする。
    if (xAxis + TOOLTIP_MAX_WIDTH <= innerWidth) merge(param, { left: xAxis })
    if (xAxis + TOOLTIP_MAX_WIDTH >= innerWidth)
      merge(param, { right: innerWidth - xAxis })
    if (yAxis + TOOLTIP_MAX_HEIGHT <= innerHight) merge(param, { top: yAxis })
    if (yAxis + TOOLTIP_MAX_HEIGHT >= innerHight)
      merge(param, { bottom: innerHight - yAxis + X_PADDING })
    setPosition(param)
  }
  const createToolTip = (id: number) => {
    const contents = (() => {
      if (type === 0) return get(addon, id)
      if (type === 1) return get(subchart, id)
      if (type === 2) return get(tools, id)
    })()
    return (
      <div style={{ ...position }} className="tech-tooltip">
        {contents()}
      </div>
    )
  }
  return { _setPosition, createToolTip }
}
